module.exports = __webpack_public_path__ + "media/images/design/images/event_search/btn_event_new-7edcba78c5e98b9d132fcdddf09abc0f.jpg";